import { SelectedFilter } from '@fiverr-private/listing_types';

export const calculateActiveFiltersCount = (selectedFiltersHierarchy: SelectedFilter[] = []): number =>
    selectedFiltersHierarchy.reduce((acc, { values }) => acc + values.length, 0);
